import { Checkbox, Form } from 'antd';
import React from 'react';
import TranslationInput from 'components/TranslationInput';
import InputInfoCircle from 'components/InputInfoCircle';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const EndingStep = ({ name, survey, translations }) => (survey ? (
  <>
    <h2>
      Survey ending
      <InputInfoCircle title={<FormattedMessage {...messages.endingHelpText} />} iconStyle={{ marginLeft: 8, width: 16 }} />
    </h2>
    <TranslationInput primary={survey} translations={translations} name={[name, 'thankYouPageContent']} />
    <Form.Item name={[name, 'clientPanel']} valuePropName="checked">
      <Checkbox>Collect respondent name and email for targeted surveys</Checkbox>
    </Form.Item>
  </>
) : null);

export default EndingStep;
